import { AddToCartLabelArgs } from '../interfaces';

export const getDescriptionPreview = (description: string, maxLength = 150) => {
  const isLongDescription = description.length > maxLength;

  return {
    isLongDescription,
    shortDescription: isLongDescription ? `${description.substring(0, maxLength)}...` : description,
  };
};

export const getAddToCartLabel = ({
  materialDataLoading,
  requiresSize,
  selectedSize,
  isAvailable,
  isOutOfStock,
  price,
}: AddToCartLabelArgs) => {
  if (materialDataLoading) return 'Loading...';
  if (requiresSize && !selectedSize) return 'Select Size';
  if (!isAvailable) return 'Unavailable';
  if (isOutOfStock) return 'Out of Stock';
  if (price <= 0) return 'Price loading';
  return 'Add to Cart';
};
